export default __webpack_public_path__ + "static/swvl-8b-e005a72d1490dc8ad86c0ff69590b82e.webp";